import { render, staticRenderFns } from "./processHazopNonRiskbook.vue?vue&type=template&id=791cdcde"
import script from "./processHazopNonRiskbook.vue?vue&type=script&lang=js"
export * from "./processHazopNonRiskbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('791cdcde')) {
      api.createRecord('791cdcde', component.options)
    } else {
      api.reload('791cdcde', component.options)
    }
    module.hot.accept("./processHazopNonRiskbook.vue?vue&type=template&id=791cdcde", function () {
      api.rerender('791cdcde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/processRam/processHazopNonRiskbook.vue"
export default component.exports